<ng-container [ngSwitch]="mode$ | async">
  <concert-main *ngSwitchCase="'concert'"></concert-main>
  <concert-grouped *ngSwitchCase="'concert-grouped'"></concert-grouped>
  <app-ticket-main *ngSwitchCase="'ticket'"></app-ticket-main>
</ng-container>
